var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"title title--line"},[_c('T',{attrs:{"title":_vm.document.title}},[_vm._v("Gelieve de achterkant van het document ook te uploaden.")])],1),_vm._v(" "),_c('a',{staticClass:"button button--ghost",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"icon-chevron-left button--icon button__icon--left"}),_vm._v(" "),_c('T',[_vm._v("Klik hier om opnieuw te proberen")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0730cc0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/OcrIdSingelSided.vue
// module id = 655
// module chunks = 0